import { Config } from '@browsing/config';

export const isSentryEnabled = (config: Config): boolean => {
    return config.isEnabled('sentry') && !!config.sentry;
};
